import {StatisticsItem} from "features/model/types/hr/getStatistics";
import {NavLink} from "react-router-dom";
import {
    renderRadialStatistic
} from "components/pages/stats/stats-table/stats-items/render-radial-statistic/RenderRadialStatistic";

interface IStatsItems {
    item: StatisticsItem;
}


export const StatsItems = ({item}: IStatsItems) => {
    return (
        <div className="row">
            <div className="col student-col full-width-mobile">
                <span className="col-title">Студент</span>
                <div className="student-data-box">
                    <div className="avatar">
                        <img src={item.avatar} alt=""/>
                        <span className={`status-label ${item.onlineStatus}`}/>
                    </div>
                    <div className="student-data">
                        <p className="name">
                            <NavLink
                                to={`/groups/${item.groupId}/students-pages/${item.userId}`}>{item.fullName}</NavLink> {" "}
                        </p>
                        <p>{item.group}</p>
                    </div>
                </div>
            </div>

            {renderRadialStatistic('Эффективность', item.efficiency)}
            {renderRadialStatistic('Посещаемость', item.attendance)}
            {renderRadialStatistic('Домашнее задание', item.homeworks)}
            {renderRadialStatistic('Последний срез', item.lastCut)}
        </div>
    );
};

